import React from 'react';
import Modal from 'components/common/modal-component';
import { ModalButton } from 'models/utils/common/modal-button-model';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

const CONFIRMATION_MODAL_BLOCK = 'confirmation-modal-block';
const ConfirmationModal = ({
  title,
  children,
  textId,
  textValues,
  onClose,
  onConfirm,
  primaryButtonText,
  secondaryButtonText,
}) => {
  return (
    <Modal
      id={CONFIRMATION_MODAL_BLOCK}
      title={title}
      onClose={onClose}
      primaryModalButton={
        new ModalButton({
          text: primaryButtonText,
          onClick: onConfirm,
        })
      }
      secondaryModalButton={
        new ModalButton({
          text: secondaryButtonText,
          onClick: onClose,
        })
      }
    >
      {children ? (
        children
      ) : (
        <div className={`${CONFIRMATION_MODAL_BLOCK}__label`}>
          <FormattedMessage id={textId} values={textValues} />
        </div>
      )}
    </Modal>
  );
};

ConfirmationModal.propTypes = {
  // Function to be called when user clicks on cross or No button of modal
  onClose: PropTypes.func.isRequired,
  // Function to be called when user clicks on Yes button of modal
  onConfirm: PropTypes.func.isRequired,
  // Title of the modal
  title: PropTypes.string,
  // Text to be displayed in the modal
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.string,
    PropTypes.element
  ]),
  // ID of the text to be displayed in the modal
  textId: PropTypes.string,
  // Values to be used in the text
  textValues: PropTypes.object,
  // Text for the primary button
  primaryButtonText: PropTypes.string.isRequired,
  // Text for the secondary button
  secondaryButtonText: PropTypes.string.isRequired,
};

export default ConfirmationModal;
